// import { TKPI } from "@/features/profile/types/profile.types";
import { GeneralParamAction } from "./general_param.action";
import generalParamTypes from "./general_param.types";

interface IGeneralParamReducerState {
    toggleBigger1: boolean,
    toggleBigger2: boolean
}

const INITIAL_STATE = {
    toggleBigger1: false,
    toggleBigger2: false
};

const generalParamReducer = (
    state: IGeneralParamReducerState = INITIAL_STATE,
    action: GeneralParamAction
): IGeneralParamReducerState => {
    switch (action.type) {

        case generalParamTypes.TOGGLE_BIGGER1:
            return {
                ...state,
                toggleBigger1: action.payload
            };

        case generalParamTypes.TOGGLE_BIGGER2:
            return {
                ...state,
                toggleBigger1: action.payload
            };

        default:
            return state;
    }
};

export default generalParamReducer;
